<template>

    <div v-if="project">

        <div class="project-name">
            {{ project.name }}
        </div>

        <div class="project-tracks-count text-stardust-grey">
            {{ project.trackcount }} Tracks.
        </div>

        <div class="form-group">

            <label>
                Tracks:
            </label>

            <table class="table">
                <thead>
                <th>
                    #
                </th>
                <th>
                    Track
                </th>
                <th>
                    Composer
                </th>
                <th>
                    Album ID
                </th>
                <th>
                    Length of Use
                </th>
                </thead>
                <tbody>
                <tr v-for="track in project.tracks" v-bind:key="track.id">
                    <td class="track-data">
                        {{ track.track_number }}
                    </td>
                    <td class="track-data">
                        {{ track.title }}
                    </td>
                    <td class="track-data">
                        {{ track.composer }}
                    </td>
                    <td class="track-data">
                        <span v-if="this.track.album">
                            {{ track.album.name }}
                        </span>
                        <span v-if="!this.track.album">
                            No Album
                        </span>
                    </td>
                    <td>
                        <div class="form-group form-control-sm mb-0">
                            <input type="time" v-model="trackDuration[track.id]" v-bind:max="track.length" class="form-control"/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>

        <a class="btn btn-raised btn-danger btn-xl font-weight-semibold" href="#" v-on:click.prevent="downloadCueSheet">
            Download
        </a>

    </div>

</template>

<script>

    import Vue from 'vue';
    import {playerService} from '../player-service';

    export default Vue.component(
        'download-cue-sheet',
        {

            data: function () {

                return {

                    project: null,
                    trackDuration: []

                };

            },

            mounted: function () {

                // Change the edit project contents depending on whats passed to it.
                playerService.$on(
                    'download-cue-sheet',
                    (project) => {

                        // Update curr track for modal.
                        this.project = project;

                        this.trackDuration = [];

                        // Open the modal.
                        window.webpackOpenBsModalWorkaround('#downloadCueSheetModal');

                    }
                );

            },

            watch: {

                project: function( value ) {

                    this.reset();

                }

            },

            methods: {

                downloadCueSheet: function () {

                    playerService.downloadCueSheet(this.project, this.trackDuration);

                },

                reset: function() {

                    this.trackDuration = [];

                }

            },

        }
    );

</script>
